import React from 'react';
import { Badge, Form, Row, Col } from 'react-bootstrap';
import { BAC_PERIODS, bacMaxDate, normalizeBacPeriod, validateBacPeriod } from '../../Utils/bacPeriods';

export default function BacPeriodSelector({ value, onChange }) {
  const keyword = normalizeBacPeriod(value.periodKeyword);
  React.useEffect(() => {
    if (keyword !== value.periodKeyword) onChange({ ...value, periodKeyword: keyword });
  }, [keyword, value, onChange]);
  const error = validateBacPeriod({ ...value, periodKeyword: keyword });
  return <div>
    <Form.Label className="fw-bold mb-2">Period</Form.Label>
    <div className="period-options d-flex gap-2 flex-wrap">
      {BAC_PERIODS.map(period => <Badge as="button" type="button" key={period}
        bg={keyword === period ? 'primary' : 'light'}
        text={keyword === period ? undefined : 'dark'}
        aria-pressed={keyword === period}
        onClick={() => onChange({ ...value, periodKeyword: period })}>
        {period.replace(/([A-Z])/g, ' $1').replace(/^./, c => c.toUpperCase())}
      </Badge>)}
    </div>
    {keyword === 'custom' && <Row className="g-2 mt-2">
      {['fromDate', 'toDate'].map((field, index) => <Col key={field}>
        <Form.Label className="small text-muted mb-1" htmlFor={`bac-${field}`}>{index === 0 ? 'From' : 'To'}</Form.Label>
        <Form.Control size="sm" id={`bac-${field}`} type="date" value={value[field] || ''}
          max={bacMaxDate()} onChange={event => onChange({ ...value, [field]: event.target.value })} />
      </Col>)}
    </Row>}
    {error && <div role="alert" className="text-danger mt-2">{error}</div>}
  </div>;
}
